// Lazy load images below the fold.
// Each images should be wrapped in a noscript so they still load.
// The JS will unwrap them, observe for in-view when possible.
const $lazyImages = $(`noscript.lazy-image`);
if (`IntersectionObserver` in window) {
  let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        let lazyImage = entry.target;
        lazyImage.src = lazyImage.getAttribute(`data-src`);
        lazyImage.removeAttribute(`data-src`);
        lazyImageObserver.unobserve(lazyImage);
      }
    });
  });

  $lazyImages.each(function() {
    const $noscript = $(this);
    let html = $noscript.text();
    const $image = $(html.replace(` src=`, ` data-src=`));
    $noscript.replaceWith($image);
    lazyImageObserver.observe($image[0]);
  });
} else {
  $lazyImages.each(function() {
    const $noscript = $(this);
    $noscript.replaceWith($noscript.text());
  });
}
